import { VERSION } from "../ducks/consts";

/**
 * Registro dos envios ao `POST /Apps/pedido`, para montar a suíte de testes da
 * API a partir de pedidos reais feitos no navegador.
 *
 * Liga no beta e no dev server; em produção fica inerte, senão isto jogaria
 * CPF, telefone e endereço de cliente no console. O projeto não usa variável de
 * ambiente, então o gate é o hostname mesmo.
 *
 * O dev server sobe com `host: true`, então a app também abre pelo IP da
 * máquina (é assim que se testa totem e POS de verdade) — nesse caso o hostname
 * é o IP e o log fica desligado. Pelo IP, use o beta.
 *
 * O testador copia tudo com um comando do DevTools: `copy(pallasPedidos)`.
 */
const DEBUG_HOSTS = ["pallas-delivery-beta.web.app", "localhost", "127.0.0.1"];

// Separada de isPedidoLogEnabled para o teste conseguir varrer a tabela: o
// `location` do jsdom é fixo por arquivo de teste.
export function isDebugHost(hostname) {
  return DEBUG_HOSTS.indexOf(hostname) !== -1;
}

export function isPedidoLogEnabled() {
  return (
    typeof window !== "undefined" &&
    !!window.location &&
    isDebugHost(window.location.hostname)
  );
}

export function logPedido(entry) {
  // Roda no caminho crítico do checkout: nada aqui pode derrubar o envio.
  try {
    if (!isPedidoLogEnabled()) return;

    if (!window.pallasPedidos) window.pallasPedidos = [];

    const record = {
      n: window.pallasPedidos.length + 1,
      ts: new Date().toISOString(),
      version: VERSION,
      url: window.location.href, // diz o modo: namespace/orderLocation/mesaId
      ...entry,
    };

    window.pallasPedidos.push(record);
    window.pallasPedido = record;

    console.group(
      `[pedido #${record.n}] ${record.status} ${record.error ? "ERRO" : "OK"}`,
    );
    console.log(record);
    console.log(
      "Copie com copy(pallasPedido) — ou copy(pallasPedidos) para todos desta sessão.",
    );
    console.groupEnd();
  } catch (err) {
    // um log quebrado não pode custar o pedido
  }
}
